import React from 'react';
import clsx from 'clsx';
import DropdownMechanism from '../../../../../GeneralComponents/DropdownMechanism';

const AnnotationAttributeRow = ({
    annotationType,
    annotationTypes,
    newSelected,
    annotationName,
    entity,
    setAnnotationType,
    setFunctionName,
    setAttributeType,
    setAnnotationTable,
    setCustomAttributeType,
    setAttributeTypeService
  }) => {
  
  // This functions updates the annotation type var according to the selected option
  const selectAnnotationType = (option) => {
    if(option !== annotationType){
      setFunctionName('none');
      setAttributeType('none');
      setAnnotationTable(false);
      setCustomAttributeType('');
      setAttributeTypeService('none');
    }
    setAnnotationType(option);
  };

  return(
      <div className={clsx('spacingTopDiv', 'flexRowDirection')}>
      <span>
        Annotation type: &nbsp; <span style={{ display: 'inline-block', marginLeft: '2.6vw' }} />{' '}
      </span>
      <span className={clsx('flexProps2')}>
        <DropdownMechanism
          target={annotationType}
          targets={annotationTypes}
          selectTarget={selectAnnotationType}
        />
        <span
          className={clsx('MuiFormHelperText-root', 'Mui-error')}
          style={
            annotationType === 'none' &&
            (newSelected === true ||
              (newSelected === false && entity !== 'none') ||
              annotationName !== '')
              ? { display: 'inherit' }
              : { display: 'none' }
          }
        >
          Annotation type none
        </span>
      </span>
    </div>
  )
};

export default AnnotationAttributeRow;
  